<template>
  <v-card
      class=" white rounded-lg"
  >
    <v-card-title class=" mr-3 mt-3 secondary--text">
      <v-img class="ml-3" src="/img/icons/order_point.svg" max-width="25"></v-img>
      {{title}}
    </v-card-title>
    <v-card-subtitle class="pr-16 primary--text">
      پنج کالای آخر
    </v-card-subtitle>
    <v-simple-table class="mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            نام کالا
          </th>
          <th class="text-center" v-if="report_type == 'orderPoint'">
            نقطه سفارش
          </th>
          <th class="text-center">
            موجودی فعلی
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="ware in orderPointWares">
          <td class="text-center">{{ware.name}}</td>
          <td class="text-center" v-if="report_type == 'orderPoint'">{{ware.minInventory}}</td>
          <td class="text-center error--text">{{ware.remain_count}}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "OrderPointTable",
  components: {
  },
  props: {
    report_type: {
      default: 'orderPoint'
    },
  },
  data() {
    return {
      orderPointWares: null,
    };
  },
  methods : {
    getDataFromApi(){
      this.request({
        url: this.endpoint(`reports/waresOrderPointReportView/${this.report_type}`),
        method: "get",
        success: data => {
          this.orderPointWares = data
          console.log(this.orderPointWares)
        }
      })
    },

  },
  mounted() {
    this.getDataFromApi()
  },
  computed: {
    title() {
      if (this.report_type == 'orderPoint') {
        return 'جدول نقطه سفارش'
      }
      else {
        return 'جدول کالای موجودی منفی'
      }
    }
  }




}
</script>

<style scoped lang="scss"></style>

